module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxOS43NDIiIGhlaWdodD0iMzkuODg1IiB2aWV3Qm94PSIwIDAgMTkuNzQyIDM5Ljg4NSI+CiAgPHBhdGggaWQ9IlBhdGhfMTY5NCIgZGF0YS1uYW1lPSJQYXRoIDE2OTQiIGQ9Ik04NC4yOTIsMTQ4Ljg0SDc4LjQxNnYxOC45MDZoLTguNzFWMTQ4Ljg0SDY1LjU2NHYtNy40aDQuMTQydi00Ljc5YzAtMy40MjUsMS42MjctOC43ODksOC43ODgtOC43ODlsNi40NTEuMDI4djcuMTg1SDgwLjI2NGExLjc3MywxLjc3MywwLDAsMC0xLjg0OCwyLjAxN3Y0LjM1Nmg2LjYzNlptMS4wMTQuMjIyIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtNjUuNTY0IC0xMjcuODYxKSIgZmlsbD0iI2ZmZiIvPgo8L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/brands/generic/social/fb.svg
// module id = 4o+6
// module chunks = 13